import { X } from "lucide-react";
import { useHairStage } from "@/lib/hairStage";

// Shows the stage a visitor picked in the quiz and lets them drop it before sending.
export const HairStageChip = ({ className = "" }) => {
  const [stage, setStage] = useHairStage();
  if (!stage) return null;
  return (
    <div className={`flex items-start justify-between gap-3 border border-gold/50 bg-gold/10 px-4 py-3 ${className}`} data-testid="hair-stage-chip">
      <p className="text-[13px] leading-snug text-ink/85">
        <span className="eyebrow block mb-0.5">Included with your request</span>
        Where am I? — <span className="font-serif text-deep-sea text-[15px]" data-testid="hair-stage-chip-value">{stage}</span>
      </p>
      <button type="button" onClick={() => setStage("")} aria-label="Remove stage from request" data-testid="hair-stage-chip-remove" className="text-ink/50 hover:text-deep-sea transition-colors duration-200 p-1 -m-1 shrink-0">
        <X className="w-4 h-4" strokeWidth={1.5} />
      </button>
    </div>
  );
};
